import React, { useRef, useState } from 'react';

import {
  Button,
  LogoutIcon,
  makeStyles,
  Menu,
  MenuItem,
  P44Logo,
  PersonIcon,
  ProfileGray,
} from '@project44/material-ui-deprecated';
import {
  RequireTranslations,
  useTranslation,
} from '@project44/translations-utils';
import { useSingleLogout, useUser } from '@project44/ui-utils';

import { translations } from '../../../l10n/config';
import { PACKAGE_NAME } from '../../utils/constants/PACKAGE_NAME';
import { MY_PROFILE_URL, VOC_URL } from '../../utils/env/env';

const useStyles = makeStyles({
  header: {
    background: '#ffffff',
    padding: '12px 16px 12px 34px',
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: '0 2px 2px 0 rgb(0 0 0 / 24%)',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginLeft: '8px',
    },
  },
  rightSideContainer: {
    display: 'flex',
    alignSelf: 'center',
  },
  profileButton: {
    padding: 0,
    '&:hover': {
      backgroundColor: '#fff',
      color: '#3c52b2',
    },
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 8,
    color: 'rgb(87, 84, 81)',
  },
  menuItemText: {
    minWidth: 80,
    fontSize: 14,
    textAlign: 'center',
  },
  menuItemIcon: {
    fontSize: 14,
  },
  userIcon: {
    height: '28px !important',
    width: '28px !important',
  },
  logo: {
    height: '35px !important',
    marginRight: 21,
    width: '102px !important',
  },
});

const MinimalNavigationBar = () => {
  const { t } = useTranslation();

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const anchorRef = useRef(null);
  const open = Boolean(anchorEl);
  const { logOutUser } = useSingleLogout();
  const { data: user } = useUser({ skipRedirectOn401: true });

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onProfileClick = () => {
    window.open(MY_PROFILE_URL, '_blank');
  };

  return (
    <>
      <header className={classes.header} data-testid="navigantion-bar-header">
        <a href={VOC_URL}>
          <P44Logo className={classes.logo} />
        </a>
        {user && (
          <div
            className={classes.rightSideContainer}
            data-testid="navigantion-bar-usermenu"
          >
            <div className={classes.iconContainer}>
              <Button
                data-testid="minimal-navigation-bar-profile-button"
                onClick={handleClick}
                ref={anchorRef}
                className={classes.profileButton}
                disableRipple
              >
                <ProfileGray className={classes.userIcon} />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <MenuItem
                  data-testid="minimal-navigantion-bar-my-profile"
                  className={classes.menuItem}
                  onClick={onProfileClick}
                >
                  <PersonIcon className={classes.menuItemIcon} />
                  <span className={classes.menuItemText}>
                    {t('user.myProfile')}
                  </span>
                </MenuItem>
                <hr style={{ color: '#f3f3f3' }} />
                <MenuItem className={classes.menuItem} onClick={logOutUser}>
                  <LogoutIcon className={classes.menuItemIcon} />
                  <span className={classes.menuItemText}>
                    {t('user.signOut')}
                  </span>
                </MenuItem>
              </Menu>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

const App = () => {
  return (
    <RequireTranslations namespace={PACKAGE_NAME} translations={translations}>
      <MinimalNavigationBar />
    </RequireTranslations>
  );
};

export default App;
